/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/components/descriptions/Row.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import * as React from 'react';
import Cell from './Cell';
import { DescriptionsContext } from '.';
function renderCells(items, { colon, prefixCls, bordered }, { component, type, showLabel, showContent, labelStyle: rootLabelStyle, contentStyle: rootContentStyle, }) {
    return items.map(({ props: { label, children, prefixCls: itemPrefixCls = prefixCls, className, style, labelStyle, contentStyle, span = 1, }, key, }, index) => {
        if (typeof component === 'string') {
            return (React.createElement(Cell, { key: `${type}-${key || index}`, className: className, style: style, labelStyle: { ...rootLabelStyle, ...labelStyle }, contentStyle: { ...rootContentStyle, ...contentStyle }, span: span, colon: colon, component: component, itemPrefixCls: itemPrefixCls, bordered: bordered, label: showLabel ? label : null, content: showContent ? children : null }));
        }
        return [
            React.createElement(Cell, { key: `label-${key || index}`, className: className, style: { ...rootLabelStyle, ...style, ...labelStyle }, span: 1, colon: colon, component: component[0], itemPrefixCls: itemPrefixCls, bordered: bordered, label: label }),
            React.createElement(Cell, { key: `content-${key || index}`, className: className, style: { ...rootContentStyle, ...style, ...contentStyle }, span: span * 2 - 1, component: component[1], itemPrefixCls: itemPrefixCls, bordered: bordered, content: children }),
        ];
    });
}
const Row = props => {
    const descContext = React.useContext(DescriptionsContext);
    const { prefixCls, vertical, row, index, bordered } = props;
    if (vertical) {
        return (React.createElement(React.Fragment, null,
            React.createElement("tr", { key: `label-${index}`, className: `${prefixCls}-row` }, renderCells(row, props, {
                component: 'th',
                type: 'label',
                showLabel: true,
                ...descContext,
            })),
            React.createElement("tr", { key: `content-${index}`, className: `${prefixCls}-row` }, renderCells(row, props, {
                component: 'td',
                type: 'content',
                showContent: true,
                ...descContext,
            }))));
    }
    return (React.createElement("tr", { key: index, className: `${prefixCls}-row` }, renderCells(row, props, {
        component: bordered ? ['th', 'td'] : 'td',
        type: 'item',
        showLabel: true,
        showContent: true,
        ...descContext,
    })));
};
export default Row;
